import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { memo, useEffect, useState } from 'react';
import classNames from 'classnames/bind';
import { prepareCardNumber } from "../../../utils/prepareCardNumber";
import { checkOptionText } from "../../utils/checkOptionText";
import style from "./styles.pcss";
var cn = classNames.bind(style);
export var OptionContentText = /*#__PURE__*/memo(function (_ref) {
  var _cn;
  var label = _ref.label,
    theme = _ref.theme,
    cardNumber = _ref.cardNumber,
    color = _ref.color,
    additionalInfo = _ref.additionalInfo,
    activeOptions = _ref.activeOptions,
    _ref$isToggle = _ref.isToggle,
    isToggle = _ref$isToggle === void 0 ? false : _ref$isToggle;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    finalText = _useState2[0],
    setFinalText = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    number = _useState4[0],
    setNumber = _useState4[1];
  useEffect(function () {
    var text = checkOptionText({
      label: label,
      activeOptions: activeOptions,
      isToggle: isToggle
    });
    setFinalText(text);
  }, [label, activeOptions, isToggle]);
  useEffect(function () {
    if (activeOptions && activeOptions.length > 1 && isToggle) {
      setNumber(activeOptions.length - 1);
    }
    if (isToggle && (!activeOptions || activeOptions.length <= 1)) {
      setNumber(null);
    }
  }, [activeOptions, isToggle]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, (label || activeOptions) && /*#__PURE__*/React.createElement("span", {
    className: cn('option-content__label', (_cn = {
      'option-content__label--secondary': theme === 'secondary',
      'option-content__label--multiple': cardNumber
    }, _defineProperty(_cn, "option-content__label--".concat(color), color), _defineProperty(_cn, 'option-content__label--ellipsis', isToggle), _cn)),
    "data-t-id": "components-OptionContentText"
  }, finalText), number && /*#__PURE__*/React.createElement("div", {
    className: cn('option-content__number')
  }, "+", number), cardNumber && /*#__PURE__*/React.createElement("div", {
    className: cn('option-content__card')
  }, prepareCardNumber(cardNumber)), additionalInfo && /*#__PURE__*/React.createElement("div", {
    className: cn('option-content__extra-node')
  }, additionalInfo));
});